import { Component, ViewChild, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { UploadSources } from 'src/app/modules/private/file-manager/models';
import { FileManagerService } from 'src/app/modules/private/file-manager/services/file-manager.service';

@Component({
  selector: 'app-attachments-modal',
  templateUrl: './attachments-modal.component.html',
  styleUrl: './attachments-modal.component.scss',
  standalone: false,
})
export class AttachmentsModalComponent {
  @ViewChild('PreviewFilesComponent') previewFilesComponent;
  readonly modal = inject(NzModalRef);
  readonly fileManagerService = inject(FileManagerService);
  readonly nzData = inject<{
    files: any[];
    index?: number;
    sourceName?: `${UploadSources}`;
    sourceId?: number;
    allowUpload?: boolean;
  }>(NZ_MODAL_DATA) ?? { files: [], index: 0, allowUpload: false };

  get displayUploadFilesButton(): boolean {
    return Boolean(
      this.nzData.allowUpload &&
        this.nzData.sourceName &&
        this.nzData.sourceId &&
        this.previewFilesComponent?.params?.files?.length
    );
  }

  uploadFiles(): void {
    const modal = this.fileManagerService.uploadPrompt(
      this.nzData.sourceName as UploadSources,
      this.nzData.sourceId
    );
    modal.afterClose.subscribe(files => {
      if (files?.length) {
        this.previewFilesComponent.params.files =
          this.previewFilesComponent.params.files.concat(files);
      }
    });
  }

  close(): void {
    this.modal.destroy(this.nzData.files);
  }
}
